<template>
  <svg width="49" height="57" viewBox="0 0 49 57" xmlns="http://www.w3.org/2000/svg">
    <path d="M49 28.5L0.25 56.6458L0.25 0.354174L49 28.5Z" />
  </svg>
</template>